import { Leaderboard } from '../components/Leaderboard';
import type { GameSnapshot } from '../types';

interface ResultsProps {
  snapshot: GameSnapshot;
  onBack: () => void;
}

export function Results({ snapshot, onBack }: ResultsProps) {
  return (
    <main className="results-page">
      <header className="top-bar">
        <button className="ghost-button" onClick={onBack} type="button">Back</button>
        <strong>{snapshot.crossword_id} Results</strong>
      </header>
      <Leaderboard
        endedAt={snapshot.ended_at}
        mode={snapshot.mode}
        players={snapshot.players}
        startedAt={snapshot.started_at}
      />
    </main>
  );
}
